"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatParser_1 = require("./formatParser");
var localization_1 = require("../localization");
var models_1 = require("../models");
var scaleSymbols = ['', 'K', 'M', 'B', 'T'];
function formatValueAsMetricNumber(value, formatString) {
    var valueString = formatMetricValueForDisplay(value, formatString);
    return addSign(valueString, value, true);
}
exports.formatValueAsMetricNumber = formatValueAsMetricNumber;
function formatValueAsRelativeNumber(value, formatString) {
    var valueString = formatMetricValueForDisplay(value, formatString);
    return addSign(valueString, value);
}
exports.formatValueAsRelativeNumber = formatValueAsRelativeNumber;
// Note: we don't want to use a format string for e.g. currency symbol, since this is always a percentage.
function formatValueAsRelativePercentage(value) {
    var valueString = formatMetricValueForDisplay(value, 'p');
    return addSign(valueString, value);
}
exports.formatValueAsRelativePercentage = formatValueAsRelativePercentage;
function formatAbsoluteValue(value, formatString) {
    var valueToFormat = value ? Math.abs(value) : undefined;
    var valueString = formatMetricValueForDisplay(valueToFormat, formatString);
    return valueString;
}
exports.formatAbsoluteValue = formatAbsoluteValue;
/**
 * This function formats the value as a positive number with currency/percentage applied.
 * @param value The number to be formatted.
 * @param formatString An optional format string containing currency and other information.
 */
function formatMetricValueForDisplay(value, formatString) {
    if (value === undefined) {
        return localization_1.Messages.metricsNoValue();
    }
    var formatInfo = formatParser_1.parseFormatString(formatString);
    if (formatInfo.dataType === formatParser_1.FormatDataType.FORMAT_NUMBER && formatInfo.isPercentage) {
        // Percentage numbers need to be multiplied by 100 to be consistent with the monolith.
        value *= 100;
    }
    // Format as a positive number with digit separators and round to 2 decimal places.
    var scaledNumber = scaleNumber(value);
    var scaledValueForDisplay = localization_1.formatNumberForLocale(scaledNumber[0]) + scaledNumber[1];
    if (formatInfo.dataType === formatParser_1.FormatDataType.FORMAT_NUMBER) {
        if (formatInfo.isPercentage) {
            scaledValueForDisplay += '%';
        }
        else {
            scaledValueForDisplay = "" + formatInfo.prefixSymbol + scaledValueForDisplay + formatInfo.postfixSymbol;
        }
    }
    return scaledValueForDisplay;
}
/**
 * This method returns the scaled absolute value of the number and the unit specifier for the scale.
 * @param value The number to be scaled
 */
function scaleNumber(value) {
    // Use the absolute value when determining the scale of the number
    var absValue = Math.abs(value);
    if (absValue < 0.01) {
        // Currently we only scale large numbers.
        // Treat small numbers as 0 because we don't know how to render them.
        return [0, ''];
    }
    if (absValue < 10000 && Number.isInteger(absValue)) {
        // The raw number looks better than the scaled version
        return [absValue, ''];
    }
    // What is the order of magnitude?  Max is 4 because of length of symbol list.
    // tslint:disable-next-line:no-bitwise
    var oOfM = Math.min((Math.log10(absValue) / 3) | 0, 4);
    // Get suffix and determine scale
    var suffix = scaleSymbols[oOfM];
    var scale = Math.pow(10, oOfM * 3);
    var scaled = absValue / scale;
    // Return the scaled number and suffix
    return [scaled, suffix];
}
/**
 * Adds the appropriate sign if it does not already exist
 * @param valueString the stringified value
 * @param value the numerical value
 * @param onlyNegative if `true` only the negative sign will be added, no plus for positive
 */
function addSign(valueString, value, onlyNegative) {
    if (value === undefined) {
        return valueString;
    }
    else if (!onlyNegative && value >= 0 && !valueString.startsWith('+')) {
        return "+" + valueString;
    }
    else if (value < 0 && !valueString.startsWith('-')) {
        return "-" + valueString;
    }
    return valueString;
}
exports.formatPillValue = function (v, formatString) {
    // tslint:disable-next-line: switch-default
    switch (v.role) {
        case models_1.MetricValueRole.CURRENT:
            return formatValueAsMetricNumber(v.value, formatString);
        case models_1.MetricValueRole.ABSOLUTE_CHANGE:
            return formatValueAsRelativeNumber(v.value, formatString);
        case models_1.MetricValueRole.PERCENTAGE_CHANGE:
            return formatValueAsRelativePercentage(v.value);
    }
};
exports.formatComparisonWidgetText = function (comparison, formatString) {
    if (comparison.absolute === 0) {
        return localization_1.Messages.metricsComparisonNoChange();
    }
    // Since the comparison widget shows up/down arrows, we format them without a sign.
    var percentage = formatMetricValueForDisplay(comparison.percentage, 'p');
    var absolute = formatMetricValueForDisplay(comparison.absolute, formatString);
    return percentage + " (" + absolute + ")";
};
// We need to polyfill a couple of functions for IE 11
// tslint:disable-next-line: no-any
var polyfillIsInteger = function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};
Number.isInteger = Number.isInteger || polyfillIsInteger;
var polyfillLog10 = function (x) {
    return Math.log(x) * Math.LOG10E;
};
Math.log10 = Math.log10 || polyfillLog10;
//# sourceMappingURL=numberFormatter.js.map